module.exports = __webpack_public_path__ + "static/img/2.1c6fc053.jpg";